<template>
  <DashboardHeader :title="client ? normalizeNames(client.name) : ' Profile'">
    <div v-if="clientNotFound">
      <v-row>
        <v-alert type="warning" class="mx-auto my-15">
          <h3>No Data Found!</h3>
        </v-alert>
        <SnackBar
          :text="snackbarText"
          :colour="snackbarColor"
          :model="snackbarModel"
        ></SnackBar>
      </v-row>
    </div>
    <div v-else>
      <v-row class="mt-4">
        <v-col :cols="isMobile ? 12 : 3">
          <SelectClient
            class="mx-6 mt-5"
            @client-selected="getClientProfile"
            @new-client-created="addClientToList"
          ></SelectClient>

          <v-card
            class="mx-6 mt-2"
            elevation="12"
            outlined
            v-if="client != null"
          >
            <v-list-item three-line>
              <v-list-item-content>
                <div class="overline mb-4">{{ getCustomerName }} Profile</div>

                <v-list-item-title class="headline mb-1">{{
                  client.name
                }}</v-list-item-title>
                <v-list-item-subtitle>{{ client.name }}</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar tile size="80" :color="getThemeColor">
                <input
                  type="file"
                  id="files"
                  ref="fileInput"
                  style="display: none"
                  accept="image/*"
                  @change="getSelectedImage()"
                />
                <v-img
                  size="80"
                  :src="profilePic"
                  style="border-radius: 50%"
                  @click="openImageDialog()"
                ></v-img>
              </v-list-item-avatar>
            </v-list-item>

            <v-list two-line>
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-card-account-details</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{
                    client.client_reference
                  }}</v-list-item-title>
                  <v-list-item-subtitle>Client Reference</v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-icon>
                  <v-icon>mdi-message-text</v-icon>
                </v-list-item-icon>
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-bank</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ client.address }}</v-list-item-title>
                  <v-list-item-subtitle>Address</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-phone</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title>{{ client.phone }}</v-list-item-title>
                  <v-list-item-subtitle>Phone</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>

              <v-divider inset></v-divider>

              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="indigo">mdi-account</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                  <v-list-item-title
                    >ID: {{ client.id_number }}</v-list-item-title
                  >

                  <v-list-item-subtitle
                    >Gender: {{ client.gender }}</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>
            </v-list>

            <v-card-actions>{{ client.notes }}</v-card-actions>
          </v-card>
        </v-col>
        <v-col :cols="isMobile ? 12 : 9">
          <v-card class="mt-4 mx-6" shaped>
            <v-tabs
              v-model="tab"
              :background-color="getThemeColor"
              :color="getSecondaryColor"
              centered
              icons-and-text
              dark
              flat
            >
              <v-tabs-slider></v-tabs-slider>
              <v-tab href="#tab-1">
                Account
                <v-icon>mdi-cash-multiple</v-icon>
              </v-tab>

              <v-tab href="#tab-2">
                Profile
                <v-icon>mdi-account-box</v-icon>
              </v-tab>
              <v-tab href="#tab-3">
                Invoices
                <v-icon>mdi-receipt</v-icon>
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item value="tab-1">
                <vExpansionPanel
                  v-if="isMobile && client"
                  title="Client Account in Numbers"
                  :class="isMobile ? 'ml-6 mr-8 mt-4' : 'mt-4'"
                >
                  <template #content>
                    <v-flex
                      md2
                      sm8
                      class="mx-auto mt-4 mb-n6"
                      v-for="(info, i) in financeTotal"
                      :key="i + Math.random()"
                    >
                      <CardAlert v-if="i < 1" :color="colors[i]">
                        {{ info.description + " " + getCurrency + " "
                        }}<input
                          size="3"
                          :style="{
                            border: 'none',
                            'border-bottom': '1px solid white',
                            'margin-top': '4px',
                          }"
                          @blur="changeQuantity()"
                          :value="info.amount"
                        />
                      </CardAlert>
                      <CardAlert v-else :color="colors[i]">
                        {{ info.description }} {{ getCurrency
                        }}{{ info.amount }}
                      </CardAlert>
                    </v-flex>
                  </template>
                </vExpansionPanel>
                <v-layout row wrap v-if="!isMobile && client != null">
                  <v-flex
                    md2
                    sm8
                    class="mx-auto mt-4 mb-n6"
                    v-for="(info, i) in financeTotal"
                    :key="i + Math.random()"
                  >
                    <CardAlert v-if="i < 1" :color="colors[i]">
                      {{ info.description + " " + getCurrency + " "
                      }}<input
                        size="3"
                        :style="{
                          border: 'none',
                          'border-bottom': '1px solid white',
                          'margin-top': '4px',
                        }"
                        @blur="changeQuantity()"
                        :value="info.amount"
                      />
                    </CardAlert>
                    <CardAlert v-else :color="colors[i]">
                      {{ info.description }} {{ getCurrency }}{{ info.amount }}
                    </CardAlert>
                  </v-flex>
                </v-layout>
                <v-row>
                  <v-col
                    :cols="isMobile ? 12 : 4"
                    class="mx-3 mt-4"
                    v-if="
                      client != null &&
                      getUserCompany.industry == 'Legal Practice'
                    "
                  >
                    <v-card class="ml-3 mt-4">
                      <v-toolbar color class="mb-1">
                        <v-toolbar-title>{{
                          getCompanyLabels.matter + "s"
                        }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                          fab
                          dark
                          x-small
                          @click="openAddDialog()"
                          v-if="isAdmin"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                        <v-btn
                          @click="getCheckboxes()"
                          dark
                          x-small
                          fab
                          right
                          v-if="indices.length > 0 && isAdmin"
                          :color="getThemeColor"
                          >Pay</v-btn
                        >
                      </v-toolbar>

                      <v-virtual-scroll
                        :items="clientCases"
                        height="400"
                        item-height="100"
                      >
                        <template v-slot:default="props">
                          <v-list two-line>
                            <v-list-item :key="props.index + Math.random()">
                              <v-list-item-content>
                                <v-list-item-subtitle
                                  v-text="props.item.title"
                                ></v-list-item-subtitle>
                                <v-list-item-subtitle
                                  v-if="props.item.court"
                                  v-text="props.item.court.name"
                                ></v-list-item-subtitle>
                                <v-list-item-subtitle
                                  v-if="props.item.status"
                                  :style="{
                                    color:
                                      props.item.status.name.includes(
                                        'omplete'
                                      ) ||
                                      props.item.status.name.includes('lose')
                                        ? 'red'
                                        : 'green',
                                  }"
                                  >{{
                                    props.item.status.name
                                  }}</v-list-item-subtitle
                                >
                              </v-list-item-content>
                              <v-list-item-action v-if="isAdmin">
                                <v-btn
                                  text
                                  color="success"
                                  @click="goToManageCases(props.item)"
                                >
                                  <v-icon>mdi-arrow-right</v-icon>
                                </v-btn>
                                <v-checkbox
                                  v-model="indices"
                                  :value="props.index"
                                ></v-checkbox>
                              </v-list-item-action>
                            </v-list-item>
                            <v-divider></v-divider>
                          </v-list>
                        </template>
                      </v-virtual-scroll>
                    </v-card>
                  </v-col>

                  <v-col
                    :cols="
                      isMobile
                        ? 11
                        : getUserCompany.industry == 'Legal Practice'
                        ? 4
                        : 5
                    "
                    class="ml-4 mt-4"
                  >
                    <v-card
                      :class="isMobile ? 'ml-2 mr-3' : 'mt-4'"
                      v-if="client != null"
                    >
                      <v-toolbar
                        :style="{
                          'background-color': paymentBannerBg,
                          color: paymentBannerColor,
                        }"
                        class="mb-1"
                      >
                        <v-toolbar-title>{{ paymentBanner }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                          fab
                          color="primary"
                          x-small
                          @click="gotoCreateInvoicesAndQuotes()"
                          v-if="isAdmin"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                        <v-btn
                          fab
                          class="ml-1"
                          :color="getThemeColor"
                          dark
                          x-small
                          @click="openViewStatementDialog()"
                          v-if="isAdmin"
                        >
                          <v-icon>mdi-receipt</v-icon>
                        </v-btn>
                      </v-toolbar>

                      <v-virtual-scroll
                        :items="clientInvoices"
                        height="400"
                        item-height="100"
                      >
                        <template v-slot:default="props">
                          <v-list-item
                            :key="props.index + Math.random() + Math.random()"
                          >
                            <v-list-item-content>
                              <v-list-item-title>{{
                                props.item.description
                              }}</v-list-item-title>
                              <v-list-item-subtitle
                                >Amount: {{ getCurrency
                                }}{{
                                  props.item.calculation.total
                                }}</v-list-item-subtitle
                              >
                              <v-list-item-subtitle
                                >Due:
                                {{ props.item.due_date }}</v-list-item-subtitle
                              >
                            </v-list-item-content>

                            <v-list-item-action>
                              <v-icon
                                @click="viewInvoice(props.item)"
                                v-if="isAdmin"
                                >mdi-pencil</v-icon
                              >
                              <v-icon
                                color="primary"
                                @click="viewInvoice(props.item)"
                                >mdi-receipt</v-icon
                              >
                              <v-icon
                                color="red"
                                @click="deletePayment(props.index)"
                                v-if="isAdmin"
                                >mdi-delete</v-icon
                              >
                            </v-list-item-action>
                          </v-list-item>
                          <v-divider></v-divider>
                        </template>
                      </v-virtual-scroll>
                    </v-card>
                  </v-col>
                  <v-col
                    :cols="
                      isMobile
                        ? 11
                        : getUserCompany.industry == 'Legal Practice'
                        ? 4
                        : 5
                    "
                    class="ml-2 mt-4"
                  >
                    <SMSIndividual
                      v-if="client"
                      :client="client"
                      :class="isMobile ? 'ml-4' : 'mt-4'"
                    ></SMSIndividual>
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item value="tab-2">
                <v-layout row wrap class="mb-2">
                  <ClientDetail
                    :client="client"
                    class="mt-8 mb-16"
                  ></ClientDetail>
                </v-layout>
              </v-tab-item>

              <v-tab-item value="tab-3">
                <v-layout row wrap>
                  <v-flex>
                    <InvoiceTable
                      class="px-4"
                      v-if="client"
                      :invoices="clientInvoices"
                      @refresh-needed="refreshClientDetails"
                    ></InvoiceTable
                  ></v-flex>
                </v-layout>
              </v-tab-item>

              <!-- <v-tab-item value="tab-3">
                <v-row>
                  <div class="ml-10">
                    <StudentIDCardFront v-if="client != null" :student="student"></StudentIDCardFront>
                  </div>
                  <div>
                    <v-switch
                      v-model="cardSwitch"
                      label="Print For Delivery"
                      @change="updateCardStatus()"
                    ></v-switch>
                  </div>
                </v-row>
              </v-tab-item>-->

              <!-- <v-tab-item value="tab-4">
                <v-content class="ma-0 pa-0" v-if="client != null">
                  <ReportTabs></ReportTabs>
                </v-content>
              </v-tab-item> -->

              <v-tab-item value="tab-5">
                <v-content class="ma-0 pa-0" v-if="client != null">
                  <v-row no-gutters>
                    <v-col>
                      <div class="d-flex flex-row align-center">
                        <v-text-field
                          class="ml-6"
                          v-model="msg"
                          :placeholder="'Message...' + client.name"
                          @keypress.enter="send"
                        ></v-text-field>
                        <v-btn
                          fab
                          dark
                          x-small
                          :color="getThemeColor"
                          class="ml-4 mr-4"
                          @click="send"
                        >
                          <v-icon>mdi-send</v-icon>
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-content>
                <v-container class="fill-height" v-if="client != null">
                  <v-row class="fill-height pb-14" align="end">
                    <v-flex
                      v-scroll.self="onScroll"
                      max-height="400"
                      class="ml-6 mr-2 overflow-y-auto"
                      v-if="chat.length > 0"
                    >
                      <div
                        v-for="(item, index) in chat"
                        :key="index + Math.random() + Math.random()"
                        :class="[
                          'd-flex flex-row align-center my-2',
                          item.from == 'user' ? 'justify-end' : null,
                        ]"
                      >
                        <v-card
                          v-if="item.from == 'user'"
                          color="#DCF8C6"
                          class="pa-4"
                          shaped
                        >
                          <span
                            v-if="item.from == 'user'"
                            class="black--text mr-3"
                            >{{ item.msg }}</span
                          >
                          <!-- <v-avatar :color="item.from == 'user' ? 'indigo': 'red'" size="36">
                          <span class="white--text">{{ item.from[0] }}</span>
                          </v-avatar>-->
                        </v-card>

                        <v-card
                          v-if="item.from != 'user'"
                          color="#fff"
                          class="pa-4"
                          shaped
                        >
                          <!-- <v-avatar :color="item.from == 'user' ? 'indigo': 'red'" size="36">
                          <span class="white--text">{{ item.from[0] }}</span>
                          </v-avatar>-->
                          <span
                            v-if="item.from != 'user'"
                            class="black--text ml-3"
                            >{{ item.msg }}</span
                          >
                        </v-card>
                      </div>
                    </v-flex>
                  </v-row>
                </v-container>
              </v-tab-item>
            </v-tabs-items>
          </v-card>
        </v-col>
        <Loader></Loader>
        <div class="text-center">
          <v-dialog v-model="dialog" min-width="500" persistent>
            <v-card>
              <v-card v-if="addCase && client">
                <v-card-title
                  :style="{
                    'backdround-color': getThemeColor,
                    color: getSecondaryColor,
                  }"
                  class="text-h5 lighten-2 ml-6"
                  >Create A New File For {{ normalizeNames(client.name) }}
                </v-card-title>

                <v-card shaped elevation="12" outlined class="mx-10">
                  <AddCase
                    :clientID="selectedClientReference"
                    @close-case-dialog="closeDialog"
                    @case-added="getAddedCase"
                  ></AddCase>
                </v-card>
              </v-card>

              <v-container>
                <v-row>
                  <v-col cols="8"></v-col>
                  <v-col cols="4"
                    ><v-btn
                      color="red"
                      dark
                      rounded
                      large
                      class="mx-auto"
                      @click="closeDialog()"
                    >
                      Cancel
                    </v-btn></v-col
                  >
                </v-row>
              </v-container>
            </v-card>
          </v-dialog>
        </div>

        <v-btn
          v-if="selectedClientReference != null && isAdmin"
          :color="getThemeColor"
          dark
          fab
          @click="noteDialog = !noteDialog"
          bottom
          right
          absolute
          class="mb-12"
          transition="slide-y-reverse-transition"
        >
          <v-icon>mdi-account-edit</v-icon>
        </v-btn>

        <!-- <v-row justify="center">
          <v-dialog v-model="noteDialog" persistent width="500">
           
          </v-dialog>
        </v-row> -->

        <v-speed-dial
          v-if="selectedClientReference != null && isAdmin"
          class="mr-16 mb-0"
          v-model="fab"
          bottom
          right
          absolute
          :direction="direction"
          :open-on-hover="hover"
          :transition="transition"
        >
          <template v-slot:activator>
            <v-btn v-model="fab" color="green accent-4" dark fab>
              <v-icon v-if="fab">mdi-close</v-icon>
              <v-icon v-else>mdi-clipboard-text</v-icon>
            </v-btn>
          </template>
          <v-btn
            rounded
            color="purple"
            small
            outlined
            class="mr-16"
            v-for="(note, i) in notes"
            :key="i + Math.random()"
          >
            <v-icon
              left
              color="green accent-4"
              class="mr-6"
              dark
              @click="readNote(note)"
              >mdi-android-messages</v-icon
            >
            {{ note.title }}
            <v-icon left color="red" class="ml-6" dark @click="deleteNote(note)"
              >mdi-delete</v-icon
            >
          </v-btn>
        </v-speed-dial>
      </v-row>
    </div>
  </DashboardHeader>
</template>

<script>
import DashboardHeader from "@/components/DashboardHeader.vue";
import Loader from "@/components/Loader.vue";
import axios from "@/plugins/axios";
// import ReportTabs from "@/components/SchoolAdmin/ReportTabs.vue";
import AddCase from "@/components/Cases/AddCase.vue";
import SnackBar from "@/components/myLibrary/SnackBar.vue";
import InvoiceTable from "@/components/InvoicesAndQuotes/InvoiceTable.vue";
import SelectClient from "@/components/Clients/SelectClient.vue";
import ClientDetail from "@/components/Clients/ClientDetail.vue";
import CardAlert from "@/components/myLibrary/CardAlert.vue";
import SMSIndividual from "@/components/SMS/SMSIndividual.vue";
import vExpansionPanel from "../Legos/vExpansionPanel.vue";
export default {
  computed: {
    hasCredits() {
      return this.messageCredit >= 1;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isStaff() {
      return this.$store.getters.isStaff;
    },
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getCompanyLabels() {
      return this.$store.getters.getCompanyLabels;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
    getCurrency() {
      return this.$store.getters.getCurrency;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    },
    computedclientProfile() {
      return this.clientProfile;
    },
    isLegalPractice() {
      return this.$store.getters.isLegalPractice;
    },
    getCustomerName() {
      return this.$store.getters.getCustomerName;
    },
  },

  mounted() {
    this.$store.commit("setScreenWidth", this.$vuetify.breakpoint.width);
    if (this.isStaff && this.$route.params.sid == undefined) {
      this.$store.commit("setLoader", true);
      axios
        .getData("/auth/get-all-clients", this.getAccessToken)
        .then((clients) => {
          this.$store.commit("setLoader", false);
          clients.forEach((client) => {
            this.clients.push({
              text: client.name + " " + " [ " + client.id_number + " ]",
              value: client.id_number,
            });
          });
        });
    } else if (this.isStaff && this.$route.params.sid != undefined) {
      this.selectedClientReference = this.$route.params.sid;
    } else {
      if (
        this.getCurrentUser != null &&
        this.getCurrentUser.sid != "00-00-000"
      ) {
        this.selectedClientReference = this.getCurrentUser.sid;
      }
    }
  },
  updated() {
    this.$store.commit("setScreenWidth", this.$vuetify.breakpoint.width);
  },
  components: {
    vExpansionPanel,
    CardAlert,
    DashboardHeader,
    Loader,
    // ReportTabs,
    AddCase,
    SnackBar,
    SelectClient,
    ClientDetail,
    InvoiceTable,
    SMSIndividual,
  },
  data: () => ({
    notes: [],
    clientCases: [],

    addClientDialog: null,
    caseTitle: null,
    caseDescription: null,
    dateCaseCaptured: null,
    casePetitioner: null,
    caseRespondent: null,
    noteID: 0,
    selectedNote: null,
    fab: false,
    direction: "top",
    hover: false,
    transition: "slide-y-reverse-transition",
    noteTitle: null,
    noteBody: null,
    cardSwitch: false,
    noteDate: new Date().toISOString().substr(0, 10),
    profilePic: null,
    nameRules: [(v) => !!v || "Field is required"],
    statementDateSelected: new Date().toISOString().substr(0, 10),
    selectedClientReference: null,
    selectedImageName: null,
    selectedImage: null,
    selectedFolder: "students_profile_pics",
    clientProfile: null,
    scrollInvoked: 0,
    chat: [],
    msg: null,
    menu: false,
    categories: [],
    commentMessage: "",
    commentSid: "",
    commentDate: "",
    noteDialog: false,
    dialog: false,
    addPay: false,
    readComment: false,
    paymentBanner: "Invoices",
    paymentBannerColor: "",
    paymentBannerBg: "",
    bills: [],
    indices: [],
    delObj: {},
    addCase: false,
    editPay: false,
    editObj: {},
    edSid: null,
    edAmount: null,
    edDescription: null,
    edDate: null,
    rules: [(value) => !!value || "Required!!"],
    deletePay: false,
    colors: ["warning", "primary", "#1B5E20", "red", "#3E2723"],
    icons: ["mdi-content-save", "mdi-credit-card"],
    financeTotal: [
      { description: "Opening", amount: "" },
      { description: "Quotes", amount: "" },
      { description: "Invoices", amount: "" },
      { description: "Paid", amount: "" },
      { description: "Outstanding", amount: "" },
    ],
    selected: [1],
    tab: null,
    clientNotFound: false,
    client: null,
    clients: [],
    clientFinanceSummary: null,
    clientInvoices: [],
    clientQuotes: [],
    clientData: [],
    guardian: null,
    statementComments: [],
    messageCredit: null,
    bulkSMS: false,
    bulkSMSBody: null,
    snackbarModel: false,
    snackbarText: null,
    snackbarColor: null,
    viewStatementDialog: false,
  }),
  methods: {
    normalizeNames(name) {
      const names = name.split(" ");
      let normalizedName = names[0];
      for (let i = 1; i < names.length; i++) {
        normalizedName += " " + names[i].charAt(0) + ".";
      }
      return normalizedName;
    },
    openImageDialog() {
      if (this.getCurrentUser.email == "adubyte2@yahoo.com") {
        document.getElementById("files").click();
      }
    },
    getSelectedImage() {
      const file = event.target.files[0];
      const ext = file.type.split("/")[1];
      this.selectedImageName = this.client.sid + "." + ext;
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.selectedImage = fileReader.result;
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/upload-image",
            {
              image64: this.selectedImage,
              name: this.selectedImageName,
              folder: this.selectedFolder,
              selectedClass: this.client.class,
            },
            this.getAccessToken
          )
          .then((images) => {
            this.profilePic = null;
            this.$store.commit("setLoader", false);
            const img =
              this.getApiUrl +
              "/images/students_profile_pics/" +
              this.getUserSchool.emis +
              "/" +
              this.client.class +
              "/" +
              this.client.sid +
              ".jpeg";

            this.profilePic = img;
          });
      });
      fileReader.readAsDataURL(file);
    },

    openViewStatementDialog() {
      this.dialog = true;
      this.viewStatementDialog = true;
    },
    addClientToList(client) {
      this.getClientMethod(client.id_number);
    },
    getStatementDateSelected(selectedDate) {
      this.statementDateSelected = selectedDate;
    },
    send() {
      // axios.postDataWithToken('/auth/send-message',{message:,sender:,receiver,threadId,})
      this.chat.push({
        from: "user",
        msg: this.msg,
      });
      this.msg = null;
      this.addReply();
    },
    addReply() {
      this.chat.unshift({
        from: "Admin",
        msg: "Thanks for reaching out to us, we will get back to you shortly",
      });
    },
    getUserProfile() {
      if (this.client != null) {
        this.clientData = [];
        const clientData = Object.entries(this.client);
        clientData.forEach((dataArr) => {
          if (
            dataArr[0] != "id" &&
            dataArr[0] != "emis" &&
            !dataArr[0].includes("sub_") &&
            !dataArr[0].includes("_at")
          ) {
            this.clientData.push(dataArr);
          }
        });
      }
    },

    openAddDialog() {
      this.dialog = true;
      this.addCase = true;
    },
    savePayment() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/save-payment",
          {
            sid: this.client.sid,
            student: this.student,
            date: this.edDate,
            amount: this.edAmount,
            descriptionId: this.edDescription,
          },
          this.getAccessToken
        )
        .then((payments) => {
          this.studentPayments = payments;

          this.paymentBannerColor = "white";
          this.paymentBannerBg = "teal";
          this.paymentBanner = "Payment Successfully Recorded!";
          this.$store.commit("setLoader", false);
          this.closeDialog();
        });
    },
    editPayment(index) {
      this.dialog = true;
      this.editPay = true;
      this.$store.commit("setLoader", true);
      this.editObj = this.studentPayments[index];
      this.edDescription = this.studentPayments[index].description;
      this.edAmount = this.studentPayments[index].amount;
      this.edSid = this.studentPayments[index].sid;
      this.edDate = this.studentPayments[index].entry_date;
      axios
        .getData("/auth/get-all-income-categories", this.getAccessToken)
        .then((categories) => {
          this.$store.commit("setLoader", false);
          this.categories = categories;
        });
    },
    saveChanges() {
      this.editObj.sid = this.edSid;
      this.editObj.description = this.edDescription;
      this.editObj.amount = this.edAmount;
      this.editObj["entry_date"] = this.edDate;
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/edit-payment",
          { editObj: this.editObj },
          this.getAccessToken
        )
        .then((payments) => {
          this.$store.commit("setLoader", false);
          this.studentPayments = payments;
          this.paymentBannerColor = "white";
          this.paymentBannerBg = "teal";
          this.paymentBanner = "Payment Successfully Updated!";
          this.$store.commit("setLoader", false);
          this.closeDialog();
        });
    },
    viewInvoice(invoice) {
      this.$router.push({
        name: "edit-and-print-invoice",
        params: { selectedInvoice: invoice },
      });
    },
    deletePayment(index) {
      this.dialog = true;
      this.deletePay = true;
      this.delObj = this.studentPayments[index];
    },
    deletePaymentNow(delObj) {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/delete-payment",
          { delObj },
          this.getAccessToken
        )
        .then((payments) => {
          this.studentPayments = payments;
          this.paymentBannerColor = "white";
          this.paymentBannerBg = "teal";
          this.paymentBanner = "Payment Successfully Deleted!";
          this.$store.commit("setLoader", false);
          this.closeDialog();
        });
    },
    goToManageCases(caseObj) {
      this.$router.push({ name: "manage-files", params: { caseObj } });
    },
    addCaseNow() {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/add-case",
          {
            selectedClientReference: this.selectedClientReference,
            caseTitle: this.caseTitle,
            caseDescription: this.caseDescription,
            casePetitioner: this.casePetitioner,
            caseRespondent: this.caseRespondent,
            dateCaseCaptured: this.dateCaseCaptured,
          },
          this.getAccessToken
        )
        .then((caseData) => {
          this.clientCases.push(caseData);
          this.$store.commit("setLoader", false);
          this.closeDialog();
        });
    },
    getCheckboxes() {
      this.indices.forEach((index) => {
        this.bills.push(this.studentFutureBillings[index]);
      });
      this.dialog = true;
      this.payBill = true;
    },
    closeDialog() {
      this.addCase = false;
      this.dialog = false;
      this.addClientDialog = false;
      this.payBill = false;
      this.editPay = false;
      this.deletePay = false;
      this.readComment = false;
      this.bills = [];
      this.indices = [];
      this.bulkSMS = false;
      this.viewStatementDialog = false;
    },
    getClientProfile(clientObj) {
      this.selectedClientReference = clientObj.id_number;
      this.getClientMethod(clientObj.id_number);
    },
    refreshClientDetails() {
      this.getClientMethod(this.client.id_number);
    },
    getClientMethod(clientReference) {
      this.cardSwitch = false;
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/get-client-profile",
          { clientReference },
          this.getAccessToken
        )
        .then((clientProfile) => {
          if (clientProfile == "not found") {
            this.$store.commit("setLoader", false);
            this.clientNotFound = true;
          } else {
            this.clientNotFound = false;
            this.clientProfile = clientProfile;
            this.client = clientProfile.client;
            this.$store.commit("setCurrentClient", clientProfile.client);
            this.$store.commit("setCurrentClientProfile", clientProfile);

            if (this.getUserCompany.industry == "Legal Practice") {
              this.clientCases = clientProfile.cases;
            }
            this.clientInvoices = clientProfile.invoices;
            this.clientQuotes = clientProfile.quotes;

            this.financeTotal[0].amount = clientProfile.arrear
              ? clientProfile.arrear.amount
              : 0;
            this.financeTotal[1].amount = clientProfile.total_quotes_issued;
            this.financeTotal[2].amount = clientProfile.total_invoices_due;
            this.financeTotal[3].amount = clientProfile.total_invoices_paid;
            this.financeTotal[4].amount =
              Number(clientProfile.total_invoices_due) -
              Number(clientProfile.total_invoices_paid);
            this.$store.commit("setLoader", false);
            //     const img =
            //       this.getApiUrl +
            //       "/images/students_profile_pics/" +
            //       this.getUserSchool.emis +
            //       "/" +
            //       this.ClientProfile.client.class +
            //       "/" +
            //       this.ClientProfile.client.sid +
            //       ".jpeg";

            //     this.profilePic = img;
          }
          //   this.getCardStatus();
        }); //end of then
    },
    onScroll() {
      this.scrollInvoked++;
    },
    readCommentNow(comment) {
      this.dialog = true;
      this.readComment = true;
      this.commentMessage = comment.body;
      this.commentSid = this.selectedClientReference || this.getCurrentUser.sid;
      this.commentDate = comment.time_stamp;
    },
    sendBulkSMSNow() {
      const bulkSMSBody = this.bulkSMSBody;
      const students = [this.selectedClientReference];
      if ([this.selectedClientReference].length > 0 && bulkSMSBody != null) {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/send-bulk-sms",
            { bulkSMSBody, students },
            this.getAccessToken
          )
          .then((messages) => {
            if (messages.length && messages.length > 0) {
              axios
                .postDataWithToken(
                  "/auth/update-messages-table-with-sent-messages",
                  { messages, origin: "student-profile" },
                  this.getAccessToken
                )
                .then((messages) => {
                  this.statementComments = messages;
                  this.$store.commit("setLoader", false);
                  this.snackbarText = "Messages Successfully Sent!";
                  this.snackbarColor = "success";
                  this.snackbarModel = true;
                });
            } else {
              this.$store.commit("setLoader", false);
              this.snackbarText = messages.detail;
              this.snackbarColor = "red";
              this.snackbarModel = true;
            }
            this.closeDialog();
          });
      } else {
        alert("Message Body Field is Required!");
        event.preventDefault();
      }
    },
    sendMessageNow() {
      const bulkSMSBody = this.bulkSMSBody;
      const senderId = this.getCurrentUser.sid;
      if (bulkSMSBody != null) {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/save-student-parent-messages",
            { bulkSMSBody, senderId },
            this.getAccessToken
          )
          .then((messages) => {
            this.statementComments = messages;
            this.$store.commit("setLoader", false);
            this.snackbarText = "Messages Successfully Sent!";
            this.snackbarColor = "success";
            this.snackbarModel = true;
          });
        this.closeDialog();
      } else {
        alert("Message Body Field is Required!");
        event.preventDefault();
      }
    },

    saveNote() {
      if (this.noteTitle == null || this.noteBody == null) {
        alert("Make Sure Note Title And Body Are Not Empty");
        event.preventDefault();
      } else {
        this.$store.commit("setLoader", true);
        const data = {
          title: this.noteTitle,
          body: this.noteBody,
          sid: this.selectedClientReference,
          date: this.noteDate,
          id: this.noteID,
        };

        axios
          .postDataWithToken("/auth/save-note", data, this.getAccessToken)
          .then((notes) => {
            this.notes = notes;
            this.$store.commit("setLoader", false);
            this.closeNoteDialog();
          });
      }
    },
    readNote(note) {
      this.noteTitle = note.title;
      this.noteBody = note.body;
      this.noteDate = note.date;
      this.noteID = note.id;
      this.noteDialog = true;
      this.selectedNote = note;
    },
    deleteNote(note) {
      this.$store.commit("setLoader", true);
      axios
        .postDataWithToken(
          "/auth/delete-note",
          { id: note.id, sid: this.selectedClientReference },
          this.getAccessToken
        )
        .then((notes) => {
          this.notes = notes;
          this.$store.commit("setLoader", false);
          this.closeNoteDialog();
        });
    },
    deleteNoteFromDialog() {
      this.deleteNote(this.selectedNote);
    },
    closeNoteDialog() {
      this.noteTitle = null;
      this.noteBody = null;
      this.noteDate = new Date().toISOString().substr(0, 10);
      this.noteID = 0;
      this.selectedNote = null;
      this.noteDialog = false;
    },
    updateCardStatus() {
      if (
        this.cardSwitch &&
        this.getCurrentUser.email == "adubyte2@yahoo.com"
      ) {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/update-card-status",
            { sid: this.client.sid },
            this.getAccessToken
          )
          .then((response) => {
            const ntn = response;
            this.$store.commit("setLoader", false);
          });
      }
    },
    getCardStatus() {
      if (
        this.client.sid &&
        this.client.sid != null &&
        this.client.sid != undefined
      ) {
        this.$store.commit("setLoader", true);
        axios
          .postDataWithToken(
            "/auth/get-card-status",
            { sid: this.client.sid },
            this.getAccessToken
          )
          .then((status) => {
            if (status == "present") {
              this.cardSwitch = true;
            } else {
              this.cardSwitch = false;
            }

            this.$store.commit("setLoader", false);
          });
      }
    },
    getAddedCase(caseObj) {
      // this.cases.push({
      //   text: `${caseObj.title} [ ${caseObj.client_reference} ]`,
      //   value: caseObj.id,
      // });
      this.clientCases.push(caseObj);
      //this.fetchCaseWithID(caseObj.id);
      this.closeDialog();
    },
    gotoCreateInvoicesAndQuotes() {
      this.$router.push({ name: "invoices-and-quotes" });
    },
  },
};
</script>

<style></style>
